import { Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import { capitalizeString } from "nhb-toolbox";
import { useNavigate } from "react-router";
import { useValidImage } from "src/hooks/useValidImage";
import { ISingleFair } from "src/Types/module/fair/singlefair";

interface Props {
	fairInfo: ISingleFair;
}

const SingleFairInfo = ({ fairInfo }: Props) => {
	const navigate = useNavigate();

	const imgSrc = useValidImage(
		fairInfo.fair_main_banner,
		"/static/images/placeholders/covers/1.jpg"
	);

	return (
		<>
			<Box sx={{ pb: 2 }}>
				<Button onClick={() => navigate(-1)}>Go back</Button>
			</Box>
			<Card sx={{ marginBottom: "45px" }}>
				<CardContent>
					<div
						style={{
							backgroundImage: `url(${imgSrc})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							height: "450px",
							backgroundPositionY: "center",
							width: "100%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							flexDirection: "column",
							boxShadow: "inset 0 0 0 2000px rgba(34,51,84, 0.7)",
							// backgroundColor: "rgba(0,0,0,0.2)",
						}}
					>
						<Typography
							textAlign='center'
							gutterBottom
							variant='h1'
							component='div'
							sx={{ opacity: 1, color: "#dee0e3" }}
						>
							{fairInfo.fair_name}
						</Typography>
						<Typography
							sx={{ opacity: 1, color: "#dee0e3" }}
							textAlign='center'
							variant='body1'
							color='text.secondary'
						>
							{fairInfo?.fair_details}
						</Typography>
					</div>
					<Box sx={{ m: 3 }}>
						<Grid
							container
							spacing={{ xs: 2, md: 3 }}
							columns={{ xs: 4, sm: 8, md: 12 }}
						>
							<Grid item xs={2} sm={4} md={4}>
								<Typography
									variant='body1'
									fontWeight='bold'
									color='text.primary'
									display='inline'
									sx={{ pr: 1 }}
									gutterBottom
								>
									Fair Name:
								</Typography>
								{fairInfo?.fair_name}
							</Grid>
							{fairInfo.fair_location && (
								<Grid item xs={2} sm={4} md={4}>
									<Typography
										variant='body1'
										fontWeight='bold'
										color='text.primary'
										display='inline'
										sx={{ pr: 1 }}
										gutterBottom
									>
										Location:
									</Typography>
									{fairInfo.fair_location}
								</Grid>
							)}
							{fairInfo.fair_start_date && (
								<Grid item xs={2} sm={4} md={4}>
									<Typography
										variant='body1'
										fontWeight='bold'
										color='text.primary'
										display='inline'
										sx={{ pr: 1 }}
										gutterBottom
									>
										Start Date:
									</Typography>
									{moment(fairInfo.fair_start_date).format(
										"LL"
									)}
								</Grid>
							)}
							{fairInfo.fair_end_date && (
								<Grid item xs={2} sm={4} md={4}>
									<Typography
										variant='body1'
										fontWeight='bold'
										color='text.primary'
										display='inline'
										sx={{ pr: 1 }}
										gutterBottom
									>
										End Date:
									</Typography>
									{moment(fairInfo.fair_end_date).format(
										"LL"
									)}
								</Grid>
							)}
							<Grid item xs={2} sm={4} md={4}>
								<Typography
									variant='body1'
									fontWeight='bold'
									color='text.primary'
									display='inline'
									sx={{ pr: 1 }}
									gutterBottom
								>
									Status:
								</Typography>
								{capitalizeString(fairInfo?.fair_status)}
							</Grid>
							{fairInfo.fair_updated_by && (
								<Grid item xs={2} sm={4} md={4}>
									<Typography
										variant='body1'
										fontWeight='bold'
										color='text.primary'
										display='inline'
										sx={{ pr: 1 }}
										gutterBottom
									>
										Updated by:
									</Typography>
									{moment(fairInfo.fair_updated_by).format(
										"LL"
									)}
								</Grid>
							)}
							{fairInfo.fair_updated_at && (
								<Grid item xs={2} sm={4} md={4}>
									<Typography
										variant='body1'
										fontWeight='bold'
										color='text.primary'
										display='inline'
										sx={{ pr: 1 }}
										gutterBottom
									>
										Updated at:
									</Typography>
									{moment(fairInfo.fair_updated_at).format(
										"LL"
									)}
								</Grid>
							)}
						</Grid>
					</Box>
				</CardContent>
			</Card>
		</>
	);
};

export default SingleFairInfo;
